

































import {Component, Vue, Watch} from "vue-property-decorator";
import KawaiiButton from "@/components/infrastructures/atoms/KawaiiButton.vue";
import httpResource from "@/components/infrastructures/functions/http/httpResource";
import KawaiiDialog from "@/components/infrastructures/atoms/KawaiiDialog.vue";

@Component({
  components: {KawaiiDialog, KawaiiButton}
})
export default class EnterpriseDeleteTab extends Vue {
  name = "EnterpriseDeleteTab.vue";

  headers = [
    // {text: "ID", value: "id"},
    {text: "ファイル名", value: "fileName"},
    {text: "LINK", value: "path"}
  ];

  selected: {}[] = [];
  vibrationList: {}[] = [];

  diabledDelete = true;

  // dialog
  dialog = false;
  dialogMessage = "";

  mounted() {
    this.fetchDMVList();
  }

  fetchDMVList() {
    httpResource.get("/upload/enterprise-dmv-list")
        .then((response: any) => {
          this.vibrationList = response.data;
        });
  }

  deleteAction() {
    if (this.diabledDelete) {
      return;
    }

    const selected = this.selected[0] as any;

    httpResource.post(`/upload/delete-enterprise-dmv?id=${selected.id}`)
        .then((response: any) => {
          this.dialogMessage = "削除に成功しました。";
          this.fetchDMVList();
        })
        .catch((error: any) => {
          // console.log(error)
          this.dialogMessage = "削除に失敗しました。";
        })
        .finally(() => {
          this.dialog = true;
        });
  }

  @Watch("selected")
  watchDiabledDelete() {
    this.diabledDelete = this.selected.length === 0;
  }
}
